




import Vue from 'vue';
import { chunkRaw, RawParamChunk } from '@/models/skills/blows/spans';

export default Vue.extend({
    name: 'RawParams',
    props: {
        raw: {
            type: String as () => string,
            required: true,
        },
        spans: {
            type: Array as () => Array<[number, number]>,
            default: () => [],
        },
    },
    computed: {
        chunks(): RawParamChunk[] {
            return chunkRaw(this.raw, this.spans);
        },
    },
});
